import * as propertyTypes from "../property_types.js"

export class DrillDownTable extends propertyTypes.Serializable {
    public label: string;
    private labelMetaData = new propertyTypes.TranslatableTextProperty("label", "Label");

    public statisticId: string;
    private statisticIdMetaData = new propertyTypes.TextProperty("statisticId", "Statistic id");

    private sourceFieldMetadata = new propertyTypes.TextProperty("sourceField", "Chart field");
    public sourceField: string;

    private destFieldMetadata = new propertyTypes.TextProperty("destField", "Control name", true);
    public destField: string;

    private hideInputControlsMetadata = new propertyTypes.CheckBoxProperty("hideInputControls", "Hide controls");
    public hideInputControls: boolean;

    private drillDownMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.drillDownMetadata = [this.labelMetaData, this.statisticIdMetaData, this.sourceFieldMetadata, this.destFieldMetadata, this.hideInputControlsMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.drillDownMetadata;
    }
}

export class DrillDown extends propertyTypes.Serializable {
    public statisticId: string;
    private statisticIdMetaData = new propertyTypes.TextProperty("statisticId", "Statistic id");

    private sourceFieldMetadata = new propertyTypes.TextProperty("sourceField", "Chart field");
    public sourceField: string;

    private destFieldMetadata = new propertyTypes.TextProperty("destField", "Control name", true);
    public destField: string;

    private hideInputControlsMetadata = new propertyTypes.CheckBoxProperty("hideInputControls", "Hide controls");
    public hideInputControls: boolean;

    private drillDownMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.drillDownMetadata = [this.statisticIdMetaData, this.sourceFieldMetadata, this.destFieldMetadata, this.hideInputControlsMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.drillDownMetadata;
    }
}

export class PlotBand extends propertyTypes.Serializable {
    private fromMetadata = new propertyTypes.TextProperty("from", "From");
    public from: string;

    private toMetadata = new propertyTypes.TextProperty("to", "To");
    public to: string;

    private colorMetadata = new propertyTypes.TextProperty("color", "Color");
    public color: string;

    private opacityMetadata = new propertyTypes.TextProperty("opacity", "Opacity");
    public opacity: string;

    private plotBandMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.plotBandMetadata = [this.fromMetadata, this.toMetadata, this.colorMetadata, this.opacityMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.plotBandMetadata;
    }
}

export class Tooltip extends propertyTypes.Serializable {
    private visibleMetadata = new propertyTypes.CheckBoxProperty("visible", "Visible");
    public visible: boolean;

    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    private toolTipMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.toolTipMetadata = [this.visibleMetadata, this.templateMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.toolTipMetadata;
    }
}